import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  Button
} from '@mui/material';

const OnErrorDialog = ({ open, onClose, title = 'Oops! Ha sucedido un error', message = 'Algo salió mal. Intenta nuevamente.' }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle textAlign={"center"}>{title}</DialogTitle>
      <DialogContent>
        <Typography variant='subtitle'>{message}</Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="outlined" color="error">
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default OnErrorDialog;
